let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    let apTextInputs = document.querySelectorAll('#avpoptions-container__v2 input[type="text"]');
    if(apTextInputs && apTextInputs.length) {
      for(let textInput of apTextInputs) {
          textInput.value = textInput.value.trim();
      }
  }
  }
}, 100);
